import React from 'react';

import classes from './style.css';
import loading from './loading.svg';

export default function Loading({ open, style, className, ...props }) {

  if (!open) return null;

  return <div
    {...props}
    style={{ backgroundImage: `url(${loading})`, ...style }}
    className={[classes.loading].concat(className || []).join(' ')}
  />;
}
